
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function UserProfileButton() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <Button
        variant="outline"
        onClick={() => navigate("/auth")}
        className="ml-3"
      >
        Sign In
      </Button>
    );
  }

  // Get user initials for avatar
  const getInitials = () => {
    if (profile?.name) {
      return profile.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);
    }
    return user.email?.substring(0, 2).toUpperCase() || "U";
  };

  // Determine avatar URL in priority order:
  // 1. Custom uploaded avatar in profile
  // 2. Google avatar from user metadata
  const avatarUrl = profile?.avatar_url || user.user_metadata?.avatar_url;

  // For debugging
  if (process.env.NODE_ENV !== 'production') {
    console.log('[Avatar Debug] profile?.avatar_url:', profile?.avatar_url);
    console.log('[Avatar Debug] user.user_metadata?.avatar_url:', user.user_metadata?.avatar_url);
    console.log('[Avatar Debug] Using avatarUrl:', avatarUrl);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage src={avatarUrl || ""} alt={profile?.name || user.email || "User"} />
            <AvatarFallback>{getInitials()}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{profile?.name || user.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/profile")}>
          Profile
        </DropdownMenuItem>
        {(profile?.role === "admin" || profile?.role === "super_admin") && (
          <DropdownMenuItem onClick={() => navigate("/admin/dashboard")}>
            Admin Dashboard
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => navigate("/polls")}>
          My Polls
        </DropdownMenuItem>
        {profile?.role === 'pollster' && profile?.verified && (
          <DropdownMenuItem onClick={() => navigate("/dashboard")}>
            Pollster Dashboard
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            signOut();
            navigate("/");
          }}
        >
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
